export default __webpack_public_path__ + "static/media/sanmat14.211a7fe9.jpg";